(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lcw-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lcw-countdown')) {
    class LcwCountdown extends HTMLElement {
      connectedCallback() {
        this._units = {};
        this.querySelectorAll('.lcw-cd__unit').forEach((u) => { this._units[u.dataset.unit] = u.querySelector('[data-v]'); });
        this._end = this._computeEnd();
        if (!this._end) { this.hidden = true; return; }
        this.hidden = false;
        this._tick();
        this._timer = setInterval(() => this._tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this._timer); }

      // Interpreta "YYYY-MM-DDTHH:MM" no fuso da loja (data-tz, ex.: -03:00)
      _parseLocal(str) {
        if (!str) return null;
        const m = str.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
        if (!m) return null;
        const t = Date.parse(`${m[1]}-${m[2]}-${m[3]}T${m[4]}:${m[5]}:00${this.dataset.tz || '-03:00'}`);
        return isNaN(t) ? null : t;
      }
      _computeEnd() {
        const now = Date.now();
        const mode = this.dataset.mode;
        if (mode === 'fixed') {
          return this._parseLocal(this.dataset.fixedEnd);
        }
        if (mode === 'evergreen') {
          const minutes = Number(this.dataset.evergreenMinutes) || 30;
          const resetHours = Number(this.dataset.evergreenResetHours) || 0;
          const key = this.dataset.key;
          let start = 0;
          try { start = Number(localStorage.getItem(key)) || 0; } catch (e) {}
          const expiredFor = now - (start + minutes * 60000);
          if (!start || (resetHours > 0 && expiredFor > resetHours * 3600000)) {
            start = now;
            try { localStorage.setItem(key, String(start)); } catch (e) {}
          }
          return start + minutes * 60000;
        }
        if (mode === 'cycle') {
          const hours = Math.max(1, Number(this.dataset.cycleHours) || 24);
          const [bh, bm] = (this.dataset.cycleBase || '00:00').split(':').map(Number);
          // base = hoje às bh:bm no fuso da loja
          const tz = this.dataset.tz || '-03:00';
          const sign = tz.startsWith('-') ? -1 : 1;
          const [th, tm] = tz.slice(1).split(':').map(Number);
          const offsetMs = sign * (th * 60 + tm) * 60000;
          const shopNow = new Date(now + offsetMs); // "relógio da loja" em UTC
          const base = Date.UTC(shopNow.getUTCFullYear(), shopNow.getUTCMonth(), shopNow.getUTCDate(), bh || 0, bm || 0) - offsetMs;
          const period = hours * 3600000;
          let end = base;
          while (end <= now) end += period;
          // se a base de hoje ainda não passou, o ciclo anterior começou ontem: garante múltiplos do período
          while (end - period > now) end -= period;
          return end;
        }
        return null;
      }
      _tick() {
        let diff = this._end - Date.now();
        if (diff <= 0 && this.dataset.mode === 'cycle') {
          // cíclico: recalcula o próximo ciclo e continua
          this._end = this._computeEnd();
          diff = this._end - Date.now();
        }
        if (diff <= 0) {
          if (this.dataset.expired === 'hide') this.hidden = true;
          this.dataset.state = 'expired';
          clearInterval(this._timer);
          return;
        }
        const s = Math.floor(diff / 1000);
        const showDays = this.dataset.showDays === 'true' && this._units.d;
        const d = Math.floor(s / 86400);
        const h = showDays ? Math.floor((s % 86400) / 3600) : Math.floor(s / 3600);
        const m = Math.floor((s % 3600) / 60);
        const sec = s % 60;
        const pad = (n) => String(n).padStart(2, '0');
        if (this._units.d) this._units.d.textContent = pad(d);
        if (this._units.h) this._units.h.textContent = pad(h);
        if (this._units.m) this._units.m.textContent = pad(m);
        if (this._units.s) this._units.s.textContent = pad(sec);
      }
    }
    customElements.define('lcw-countdown', LcwCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lcw-pdp-video"] && !Shopify.designMode) return;
  try {
    class LcwPdpVideo extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.lcw-pvideo__track');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');
      this.trackingOn = this.dataset.tracking === 'true';
      this.autoplayOn = this.dataset.autoplay === 'true';
      this.listId = this.dataset.listId || 'lcw_pdp_video';

      this.bindArrows();
      this.bindSlides();
      this.setupCarouselAutoplay();
      this.updateArrows();
      this.track && this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
    }

    bindArrows() {
      [this.prevBtn, this.nextBtn].forEach((btn) => {
        if (!btn) return;
        btn.addEventListener('click', () => {
          const dir = btn.dataset.direction === 'next' ? 1 : -1;
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: 'smooth' });
        });
      });
    }

    updateArrows() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      this.prevBtn.toggleAttribute('disabled', scrollLeft <= 1);
      this.nextBtn.toggleAttribute('disabled', scrollLeft >= scrollWidth - clientWidth - 1);
    }

    setupCarouselAutoplay() {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.autoplayOn || reduce) return;
      const vids = this.querySelectorAll('.lcw-pvideo__cvideo');
      if (!vids.length || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) { v.muted = true; v.play().catch(() => {}); } else { v.pause(); }
        });
      }, { threshold: 0.5 });
      vids.forEach((v) => io.observe(v));
    }

    bindSlides() {
      const slides = Array.from(this.querySelectorAll('.lcw-pvideo__slide'));
      slides.forEach((slide, idx) => {
        const trigger = slide.querySelector('.lcw-pvideo__trigger');
        const dialog = slide.querySelector('.lcw-pvideo__modal');
        if (!trigger || !dialog) return;
        const video = dialog.querySelector('.lcw-pvideo__modal-video > video');

        trigger.addEventListener('click', () => this.openModal(dialog, video, slide));
        dialog.querySelector('.lcw-pvideo__close')?.addEventListener('click', () => this.closeModal(dialog, video));
        dialog.addEventListener('click', (e) => { if (e.target === dialog) this.closeModal(dialog, video); });
        dialog.addEventListener('close', () => { if (video) video.pause(); });

        const prevNav = dialog.querySelector('[data-modal-nav="prev"]');
        const nextNav = dialog.querySelector('[data-modal-nav="next"]');
        if (slides.length <= 1) {
          prevNav && (prevNav.hidden = true);
          nextNav && (nextNav.hidden = true);
        } else {
          prevNav?.addEventListener('click', () => this.gotoSlide(slides, idx, -1));
          nextNav?.addEventListener('click', () => this.gotoSlide(slides, idx, 1));

          const videoWrap = dialog.querySelector('.lcw-pvideo__modal-video');
          if (videoWrap) {
            let startX = 0, startY = 0, tk = false;
            videoWrap.addEventListener('touchstart', (e) => { const t = e.changedTouches[0]; startX = t.clientX; startY = t.clientY; tk = true; }, { passive: true });
            videoWrap.addEventListener('touchend', (e) => {
              if (!tk) return; tk = false;
              const t = e.changedTouches[0];
              const dx = t.clientX - startX, dy = t.clientY - startY;
              if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.gotoSlide(slides, idx, dx < 0 ? 1 : -1);
            }, { passive: true });
          }
        }

        dialog.querySelector('[data-action="playpause"]')?.addEventListener('click', () => {
          if (!video) return;
          video.paused ? video.play() : video.pause();
        });
        dialog.querySelector('[data-action="mute"]')?.addEventListener('click', () => {
          if (!video) return;
          video.muted = !video.muted;
          dialog.classList.toggle('is-muted', video.muted);
        });
        if (video) {
          video.addEventListener('play', () => dialog.classList.add('is-playing'));
          video.addEventListener('pause', () => dialog.classList.remove('is-playing'));
          this.bindTimeline(dialog, video);
        }

        dialog.querySelectorAll('.lcw-pvideo__atc-form form').forEach((form) => {
          form.addEventListener('submit', () => this.trackAddToCart(slide));
        });
      });
    }

    bindTimeline(dialog, video) {
      const timeline = dialog.querySelector('.lcw-pvideo__timeline');
      const fill = dialog.querySelector('.lcw-pvideo__timeline-fill');
      if (!timeline || !fill) return;
      video.addEventListener('timeupdate', () => {
        fill.style.width = (video.duration ? (video.currentTime / video.duration) * 100 : 0) + '%';
      });
      timeline.addEventListener('click', (e) => {
        const rect = timeline.getBoundingClientRect();
        const ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
        if (video.duration) video.currentTime = ratio * video.duration;
      });
    }

    openModal(dialog, video, slide) {
      dialog.showModal();
      if (video) {
        video.muted = false;
        dialog.classList.remove('is-muted');
        video.play().then(() => dialog.classList.add('is-playing')).catch(() => {
          video.muted = true; dialog.classList.add('is-muted'); video.play().catch(() => {});
        });
      }
      this.trackSelect(slide);
    }

    closeModal(dialog, video) {
      if (video) video.pause();
      dialog.close();
    }

    gotoSlide(slides, idx, dir) {
      const cur = slides[idx];
      const curDialog = cur.querySelector('.lcw-pvideo__modal');
      const curVideo = curDialog.querySelector('.lcw-pvideo__modal-video > video');
      const n = (idx + dir + slides.length) % slides.length;
      const nx = slides[n];
      const nxDialog = nx.querySelector('.lcw-pvideo__modal');
      const nxVideo = nxDialog.querySelector('.lcw-pvideo__modal-video > video');
      this.closeModal(curDialog, curVideo);
      requestAnimationFrame(() => this.openModal(nxDialog, nxVideo, nx));
    }

    push(event) {
      if (!this.trackingOn) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(event);
      if (typeof window.gtag === 'function') window.gtag('event', event.event, event.ecommerce || {});
    }
    itemFrom(slide) {
      const el = slide.querySelector('[data-product-id]') || slide;
      return { item_id: el.dataset.productId, item_name: el.dataset.productTitle, price: parseFloat(el.dataset.productPrice) || undefined, item_list_id: this.listId, item_list_name: 'LCW PDP Video' };
    }
    trackSelect(slide) { this.push({ event: 'select_item', ecommerce: { item_list_id: this.listId, items: [this.itemFrom(slide)] } }); }
    trackAddToCart(slide) {
      const item = this.itemFrom(slide);
      this.push({ event: 'add_to_cart', ecommerce: { currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : undefined, value: item.price, items: [item] } });
    }
  }
  if (!customElements.get('lcw-pdp-video')) customElements.define('lcw-pdp-video', LcwPdpVideo);
  } catch(e) { console.error(e); }
})();

})();
